<template>
  <Chatbox msg="Welcome to Your Vue.js App"/>
</template>

<script>
import Chatbox from './components/Chatbox.vue'

export default {
  name: 'App',
  components: {
    Chatbox
  }
}
</script>

<style>
@import url('https://fonts.googleapis.com/css2?family=Montserrat:ital,wght@0,100..900;1,100..900&display=swap');

#app {
  font-family: "Fractul", Sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  text-align: center;
  color: #FFFFFF;
}
body{
  margin:0px;
  background-color: #FFFFFF;
}

/* ==============================
   FRACTUL
   ============================== */
@font-face {
  font-family: "Fractul";
  src: url("@/assets/fonts/Fractul-Hairline.otf") format("opentype");
  font-weight: 100;
  font-style: normal;
}
@font-face {
  font-family: "Fractul";
  src: url("@/assets/fonts/Fractul-HairlineItalic.otf") format("opentype");
  font-weight: 100;
  font-style: italic;
}

@font-face {
  font-family: "Fractul";
  src: url("@/assets/fonts/Fractul-Thin.otf") format("opentype");
  font-weight: 200;
  font-style: normal;
}
@font-face {
  font-family: "Fractul";
  src: url("@/assets/fonts/Fractul-ThinItalic.otf") format("opentype");
  font-weight: 200;
  font-style: italic;
}

@font-face {
  font-family: "Fractul";
  src: url("@/assets/fonts/Fractul-Light.otf") format("opentype");
  font-weight: 300;
  font-style: normal;
}
@font-face {
  font-family: "Fractul";
  src: url("@/assets/fonts/Fractul-LightItalic.otf") format("opentype");
  font-weight: 300;
  font-style: italic;
}

@font-face {
  font-family: "Fractul";
  src: url("@/assets/fonts/Fractul-Regular.otf") format("opentype");
  font-weight: 400;
  font-style: normal;
}
@font-face {
  font-family: "Fractul";
  src: url("@/assets/fonts/Fractul-Italic.otf") format("opentype");
  font-weight: 400;
  font-style: italic;
}

@font-face {
  font-family: "Fractul";
  src: url("@/assets/fonts/Fractul-Medium.otf") format("opentype");
  font-weight: 500;
  font-style: normal;
}
@font-face {
  font-family: "Fractul";
  src: url("@/assets/fonts/Fractul-MediumItalic.otf") format("opentype");
  font-weight: 500;
  font-style: italic;
}

@font-face {
  font-family: "Fractul";
  src: url("@/assets/fonts/Fractul-SemiBold.otf") format("opentype");
  font-weight: 600;
  font-style: normal;
}
@font-face {
  font-family: "Fractul";
  src: url("@/assets/fonts/Fractul-SemiBoldItalic.otf") format("opentype");
  font-weight: 600;
  font-style: italic;
}

@font-face {
  font-family: "Fractul";
  src: url("@/assets/fonts/Fractul-Bold.otf") format("opentype");
  font-weight: 700;
  font-style: normal;
}
@font-face {
  font-family: "Fractul";
  src: url("@/assets/fonts/Fractul-BoldItalic.otf") format("opentype");
  font-weight: 700;
  font-style: italic;
}

@font-face {
  font-family: "Fractul";
  src: url("@/assets/fonts/Fractul-ExtraBold.otf") format("opentype");
  font-weight: 800;
  font-style: normal;
}
@font-face {
  font-family: "Fractul";
  src: url("@/assets/fonts/Fractul-ExtraBoldItalic.otf") format("opentype");
  font-weight: 800;
  font-style: italic;
}

@font-face {
  font-family: "Fractul";
  src: url("@/assets/fonts/Fractul-Black.otf") format("opentype");
  font-weight: 900;
  font-style: normal;
}
@font-face {
  font-family: "Fractul";
  src: url("@/assets/fonts/Fractul-BlackItalic.otf") format("opentype");
  font-weight: 900;
  font-style: italic;
}


/* ==============================
   FRACTUL ALT
   ============================== */
@font-face {
  font-family: "Fractul Alt";
  src: url("@/assets/fonts/FractulAlt-Hairline.otf") format("opentype");
  font-weight: 100;
  font-style: normal;
}
@font-face {
  font-family: "Fractul Alt";
  src: url("@/assets/fonts/FractulAlt-HairlineItalic.otf") format("opentype");
  font-weight: 100;
  font-style: italic;
}

@font-face {
  font-family: "Fractul Alt";
  src: url("@/assets/fonts/FractulAlt-Thin.otf") format("opentype");
  font-weight: 200;
  font-style: normal;
}
@font-face {
  font-family: "Fractul Alt";
  src: url("@/assets/fonts/FractulAlt-ThinItalic.otf") format("opentype");
  font-weight: 200;
  font-style: italic;
}

@font-face {
  font-family: "Fractul Alt";
  src: url("@/assets/fonts/FractulAlt-Light.otf") format("opentype");
  font-weight: 300;
  font-style: normal;
}
@font-face {
  font-family: "Fractul Alt";
  src: url("@/assets/fonts/FractulAlt-LightItalic.otf") format("opentype");
  font-weight: 300;
  font-style: italic;
}

@font-face {
  font-family: "Fractul Alt";
  src: url("@/assets/fonts/FractulAlt-Regular.otf") format("opentype");
  font-weight: 400;
  font-style: normal;
}
@font-face {
  font-family: "Fractul Alt";
  src: url("@/assets/fonts/FractulAlt-Italic.otf") format("opentype");
  font-weight: 400;
  font-style: italic;
}

@font-face {
  font-family: "Fractul Alt";
  src: url("@/assets/fonts/FractulAlt-Medium.otf") format("opentype");
  font-weight: 500;
  font-style: normal;
}
@font-face {
  font-family: "Fractul Alt";
  src: url("@/assets/fonts/FractulAlt-MediumItalic.otf") format("opentype");
  font-weight: 500;
  font-style: italic;
}

@font-face {
  font-family: "Fractul Alt";
  src: url("@/assets/fonts/FractulAlt-SemiBold.otf") format("opentype");
  font-weight: 600;
  font-style: normal;
}
@font-face {
  font-family: "Fractul Alt";
  src: url("@/assets/fonts/FractulAlt-SemiBoldItalic.otf") format("opentype");
  font-weight: 600;
  font-style: italic;
}

@font-face {
  font-family: "Fractul Alt";
  src: url("@/assets/fonts/FractulAlt-Bold.otf") format("opentype");
  font-weight: 700;
  font-style: normal;
}
@font-face {
  font-family: "Fractul Alt";
  src: url("@/assets/fonts/FractulAlt-BoldItalic.otf") format("opentype");
  font-weight: 700;
  font-style: italic;
}

@font-face {
  font-family: "Fractul Alt";
  src: url("@/assets/fonts/FractulAlt-ExtraBold.otf") format("opentype");
  font-weight: 800;
  font-style: normal;
}
@font-face {
  font-family: "Fractul Alt";
  src: url("@/assets/fonts/FractulAlt-ExtraBoldItalic.otf") format("opentype");
  font-weight: 800;
  font-style: italic;
}

@font-face {
  font-family: "Fractul Alt";
  src: url("@/assets/fonts/FractulAlt-Black.otf") format("opentype");
  font-weight: 900;
  font-style: normal;
}
@font-face {
  font-family: "Fractul Alt";
  src: url("@/assets/fonts/FractulAlt-BlackItalic.otf") format("opentype");
  font-weight: 900;
  font-style: italic;
}
</style>
